// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ResizeIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Resize/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "m18 20 2.5-2.667m0-5.833L12.667 20M20 6 6.5 20"
}));
export default ResizeIcon;